import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import Translator from '../../../requests/apa/Translator';
import Assets from '../../../requests/apa/Asset';
import { autobind } from 'packages/core/lib';
import { showModal, AAF_MODAL_ERROR } from '../../../actions/modal';
import AAF from '../../../AAF/AAF';
import { LoadRegisterLabels } from './'
import RegisterLogic from '../../Register/RegisterLogic';
import { receiveIsLoggedIn, fetchPushSession } from '../../../reducers/user';
import { setMetricsEvent } from "../../../actions/metrics";
import UtilsProfile from '../../../utils/Profile';
import logger from 'src/utils/logger/logger';
import './_styles.scss';

interface ILoadRegisterIpTelmexState {
  isLoading: boolean
}

class LoadRegisterIpTelmex extends Component<RouteComponentProps, ILoadRegisterIpTelmexState> {

  private registerLogic: RegisterLogic;

  constructor(props: RouteComponentProps) {
    super(props);
    this.registerLogic = new RegisterLogic(this.props);
    this.state = {
      isLoading: false
    }
  }

  componentDidMount = () => {

    const { isLoading } = this.state;




    if (!isLoading) {
      this.registerIpTelmex();
    }
  };

  @autobind
  registerIpTelmex() {

    const { user = {} } = this.props;
    const { userDetectWS = {} } = user;

    this.setState({ isLoading: true })
    AAF.Auth.iptelmex.registerWithoutMail(userDetectWS, user).then(this.registerSuccess).catch(this.registerFail);

  }

  registerSuccess = (resp: any) => {
    const { history, user } = this.props;
    const { response: { firstname = '', lastname = '' } = {}, response } = resp;

    this.registerLogic.successRegisterIpTelmex(response).then(() => {
      if (UtilsProfile.isProfileEnable(user)) {
        history.replace('/profile');
      } else {
        history.push('/node/homeuser');
      }
    }).catch((err) => {
      logger.error(err);

    });
  }

    registerFail = (err: object) => {
        this.props.showModal({
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                content: err.response,
                callback: () => {
                    const { history } = this.props;
                    history.push('/landing');
                }
            }
        });
    }


  render() {
    return <LoadRegisterLabels
      firstImage={Assets.get('iptelmex_configuration_logoClarovideo', '')}
      secondImage={Assets.get('iptelmex_configuration_loading', '')}
      firstText={Translator.get('iptelmex_configuration_title_label')}
      secondText={Translator.get('iptelmex_configuration_description_label', 'Al ser cliente Telmex cuentas con acceso directo a claro video con tu dirección IP. Espera un momento estamos configurando tu cuenta')}
    />
  }
}


const mapStateToProps = (state: any): object => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, { showModal, receiveIsLoggedIn, setMetricsEvent, fetchPushSession })(LoadRegisterIpTelmex);




// WEBPACK FOOTER //
// ./src/authentication/components/LoadRegisterIPtelmex/container.tsx